import { AmbientLight, DirectionalLight, PerspectiveCamera, Scene, WebGLRenderer } from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { gConf } from './modules/world/config.js';
import { initGlobe } from './modules/world/globe.js';
import { SELECTORS } from './modules/world/init.js';

export let renderer, camera, scene, controls;

const initRenderer = () => {
	// Initialize renderer
	renderer = [new WebGLRenderer({ antialias: true, alpha: true }), new CSS2DRenderer()];
	renderer.forEach((r, idx) => {
		r.setSize(gConf.window.width, gConf.window.height, false);

		if (idx > 0) {
			// overlay additional on top of main renderer
			r.domElement.style.position = 'absolute';
			r.domElement.style.top = '0px';
			r.domElement.style.pointerEvents = 'none';
		}

		document.querySelector(SELECTORS.map).appendChild(r.domElement);
	});
};

const initScene = () => {
	// Initialize scene, light
	scene = new Scene();
	scene.add(new AmbientLight(0xffffff, Math.PI));
	scene.add(new DirectionalLight(0x000000, 0.6 * Math.PI));
};

const initCamera = () => {
	// Initialize camera, light
	camera = new PerspectiveCamera();
	camera.position.y = gConf.camera.radius;
	camera.position.z = gConf.camera.radius;
	camera.updateProjectionMatrix();

	scene.add(camera);
};

const initCameraControls = () => {
	// Initialize controls
	controls = new OrbitControls(camera, renderer[0].domElement);
	controls.enableDamping = true;
	controls.dynamicDampingFactor = 0.01;
	controls.enablePan = false;
	controls.enableZoom = false;
	controls.rotateSpeed = 0.8;
	controls.zoomSpeed = 1;
	controls.autoRotate = false;

	// Adjust the angle of the globe so that all our countries are best displayed.
	const maxPoleAngle = 0.6;
	controls.minPolarAngle = maxPoleAngle;
	controls.maxPolarAngle = maxPoleAngle;
};

const animateScene = () => {
	renderer.forEach((r) => r.render(scene, camera));

	// updateMarkers();
	camera.lookAt(scene.position);
	controls.update();
	requestAnimationFrame(animateScene);
};

const destroyWorldForever = () => {
	camera = null;
	scene = null;
	controls = null;
	renderer.forEach((r) => {
		document.querySelector(SELECTORS.map).removeChild(r.domElement);
	});

	// clear canvas
	const canvas = document.querySelector(SELECTORS.map).querySelector('canvas');
	if (canvas) {
		const context = canvas.getContext('2d');

		// Clear the entire canvas
		context.clearRect(0, 0, canvas.width, canvas.height);
	}
};

const initWorld = () => {
	initRenderer();
	initScene();
	initCamera();
	initCameraControls();
	initGlobe();
	animateScene();
};

// add new dispatched event listener
document.addEventListener('colorModeChange', () => {
	if (scene !== null && renderer !== undefined) {
		destroyWorldForever();
	}
	initWorld();
});

initWorld();
